import { Injectable } from '@angular/core';

import { InitConstant, UrlConstant, DialogConstant } from '../Constant';

import { AuthService } from './auth.service';
import { DialogService } from './dialog.service';
import { ApiService } from './api.service';
import { LogService } from './log.service';

@Injectable({
    providedIn: 'root'
})
export class DownloadService
{
    private mime_types = InitConstant.THUMBNAIL_MIME_TYPES;

    constructor(
        private auth: AuthService,
        private dialog: DialogService,
        private api: ApiService,
        private log: LogService
    )
    {
    }

    async thumb(file)
    {
        const parent_id = (this.auth.empty(file.parent_id) ? "" : file.parent_id);

        if (this.mime_types.includes(file.mime_type) === false) {
            return;
        }

        let file_name = file.id+'.jpg';

        if (file.mime_type.match(/gif$/)) {
            file_name = file.id+'.gif';
        } else if (file.mime_type.match(/png$/)) {
            file_name = file.id+'.png';
        }

        const blob = await this.api.getthumbnail(file.id);
        const proc_id = `getthumbnail:`+file.id;

        if (!this.api.isSuccess(proc_id)) {
            return;
        }

        if (this.auth.empty(blob)) {
            return;
        }

        const url = URL.createObjectURL(blob);
        file.thumb = `background-image: url(${url})`;
    }

    async zipdownload(file)
    {
        const token = await this.auth.getToken();
        const url = UrlConstant.BASE+UrlConstant.PC_ZIPDOWNLOAD+`/${token}/${file.dl_id}`;

        let a = <HTMLAnchorElement>document.createElement('A');
        a.download = `${file.created}.zip`;
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
}
